module.exports = __webpack_public_path__ + "static/media/31-8.39534d88.mp3";